module.exports = new __parcel__URL__("assembly.85d9e9ee.jpg").toString();